import ForbiddenPage from "./ForbiddenPage";
import NotFoundPage from "./NotFoundPage";

const routes = [
  {
    path: 'forbidden',
    name: 'forbidden',
    component: ForbiddenPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'not-found',
    name: 'not-found',
    component: NotFoundPage,
    meta: {
      requiresAuth: true
    }
  },
];

export {routes}

